import Repository from './repository'
const resource = '/event_tags'

export default {
  getEvents (eventTagIds, excludeEventIds) {
    return Repository.get(`${resource}/events.json`, {
      params: {
        event_tag_ids: eventTagIds,
        exclude_event_ids: excludeEventIds
      }
    })
  }
}
